import Vue from 'vue';
import App from './App.vue';
import { routerStatic } from './router';
import store from './store';
import { firestorePlugin } from 'vuefire';
import InstantSearch from 'vue-instantsearch';
import moment from 'moment';
import 'moment/locale/ja';
import * as VueMoment from 'vue-moment';
import VueAnalytics from 'vue-analytics';
import Vuetify from 'vuetify/lib/framework';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

const vuetify = new Vuetify({
    theme: {
        themes: {
            light: {
                primary: colors.deepPurple,
                secondary: colors.grey,
                accent: colors.shades.black,
                error: colors.red.accent3,
            },
            dark: {
                primary: colors.blue.lighten3,
            },
        },
    },
});

Vue.use(VueAnalytics, {
    id: '279305210',
    router: routerStatic,
    autoTracking: {
        screenview: true
    }
});
Vue.use(InstantSearch);
Vue.use(firestorePlugin);
Vue.use(VueMoment, { moment });
Vue.config.productionTip = false;
Vue.prototype.$static = true;

new Vue({
    router: routerStatic,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
